"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelectModal = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LanguageSelectModal = props => {
  const {
    onLanguageChange,
    isOpen,
    onClose
  } = props;
  const {
    translations,
    languages
  } = (0, _contexts.useConfiguration)();
  const [selectedLanguageCode, setSelectedLanguageCode] = (0, _react.useState)(undefined);
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const handleLanguageChange = (0, _react.useCallback)(language => onLanguageChange(language), [onLanguageChange]);
  const handleKeyDown = (0, _react.useCallback)(event => {
    // If there are no languages yet then exit prematurely
    if (!languages) {
      return;
    }
    const selectedIndex = languages.findIndex(language => language.code === selectedLanguageCode);
    let newSelectedIndex = selectedIndex;
    switch (event.code) {
      case 'ArrowDown':
        {
          newSelectedIndex = selectedIndex + 1 < languages.length ? selectedIndex + 1 : 0;
          break;
        }
      case 'ArrowUp':
        {
          newSelectedIndex = selectedIndex - 1 >= 0 ? selectedIndex - 1 : languages.length - 1;
          break;
        }
      case 'Enter':
        {
          const selectedLanguage = languages.find(language => language.code === selectedLanguageCode);
          if (!selectedLanguage) {
            return;
          }
          handleLanguageChange(selectedLanguage);
          break;
        }
      default:
    }
    setSelectedLanguageCode(languages[newSelectedIndex]?.code);
  }, [languages, handleLanguageChange, selectedLanguageCode]);
  const handleItemMouseEnter = (0, _react.useCallback)(event => {
    const languageCode = event.currentTarget.dataset.langCode;
    setSelectedLanguageCode(languageCode);
  }, []);
  const handleListItemButtonClick = (0, _react.useCallback)(event => {
    // If there are no languages yet then exit prematurely
    if (!languages) {
      return;
    }
    const languageCode = event.currentTarget.dataset.langCode;
    const language = languages.find(availableLanguage => availableLanguage.code === languageCode);
    if (!language) {
      return;
    }
    handleLanguageChange(language);
  }, [languages, handleLanguageChange]);
  const handleItemMouseLeave = (0, _react.useCallback)(() => {
    setSelectedLanguageCode(undefined);
  }, []);

  // We are probably still loading
  if (!languages || languages.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDialog, {
    closeAfterTransition: true,
    disableEnforceFocus: true,
    disableRestoreFocus: true,
    transitionProps: _constants.transitionProps,
    disablePortal: false,
    "aria-describedby": "transition-modal-description",
    "aria-labelledby": "transition-modal-title",
    open: !!isOpen,
    header: translations?.selectLanguage,
    onKeyDown: handleKeyDown,
    onClose: onClose,
    ...getTestIdProps(_models.LanguageSelectPopupTestIds.ROOT),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledList, {
      ...getTestIdProps(_models.LanguageSelectPopupTestIds.LIST),
      children: languages.map((lang, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ListItem, {
          disablePadding: true,
          "data-lang-code": lang.code,
          "aria-label": lang.name,
          onMouseEnter: handleItemMouseEnter,
          onMouseLeave: handleItemMouseLeave,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledListItemButton, {
            ...getTestIdProps(`${_models.LanguageSelectPopupTestIds.LIST_ITEM}_${lang.code}`),
            disableGutters: true,
            "data-lang-code": lang.code,
            selected: selectedLanguageCode === lang.code,
            onClick: handleListItemButtonClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledListItemText, {
              disableTypography: true,
              primary: lang.name
            })
          })
        }), index < languages.length - 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDivider, {
          isItemHovered: selectedLanguageCode !== undefined
        }, `divider_${lang.code}`)]
      }, `item_${lang.code}`))
    })
  });
};
exports.LanguageSelectModal = LanguageSelectModal;